<mat-tab-group class="quickpanel" fxFlex>
  <mat-tab label="Status">
    <dva-scrollbar class="overflow-container" fxLayout="center">
      <div fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center">
        <div class="status" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayoutAlign="center center">
            <p class="h1">
              <span fxLayout="start"> {{ 'ProgressPanel.Title' | translate }}</span>
            </p>
          </div>
          <div class="icon" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
          </div>
        </div>
        <mat-form-field fxFlex="auto">
          <mat-label>{{ 'Commons.Date' | translate }}</mat-label>
          <input
            (click)="datePickerRef.open()"
            [(ngModel)]="date"
            (dateChange)="refresh()"
            [matDatepicker]="datePickerRef"
            matInput
            readonly
          />
          <mat-datepicker-toggle [for]="datePickerRef" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #datePickerRef></mat-datepicker>
        </mat-form-field>
        <mat-divider></mat-divider>
        <div fxLayout="column" fxLayoutGap="8px" fxLayout.gt-sm="row">
          <div fxFlex="auto" style="width: 350px">
            <div *ngIf="!hasValidationsAwaiting() && !hasProcessingValidations() && !hasValidationsCompleted()">
              <span fxLayout="start" class="status"> {{ 'ProgressPanel.NoData' | translate }}</span>
            </div>
            <div *ngIf="hasValidationsAwaiting()" fxLayout="column">
              <span fxLayout="start" class="status"> {{ 'ProgressPanel.Waiting' | translate }}</span>
              <div fxLayout="column" fxFill fxLayoutAlign=" stretch">
                <ng-container *ngFor="let item of validationsAwaiting; let lastItem = last">
                  <div
                    fxFill
                    fxLayout="row"
                    fxLayoutAlign="center"
                    fxLayoutGap="0.5em"
                    (click)="selectWorkflow(item)"
                    class="text-padding"
                    [ngClass]="{ selected: isWorkflowSelected(item) }"
                  >
                    <mat-icon [ngStyle]="{ color: '#889093' }">pending</mat-icon>
                    <div fxFill fxLayout="column" fxLayoutGap="0.5em">
                      <div class="validation-name" [matTooltip]="item.name" matTooltipClass="big-tooltip">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <mat-divider *ngIf="!lastItem"></mat-divider>
                </ng-container>
              </div>
            </div>
            <div *ngIf="hasProcessingValidations()" fxLayout="column">
              <span fxLayout="start" class="status"> {{ 'ProgressPanel.InProgress' | translate }}</span>
              <div fxFill fxLayout="column" fxLayoutAlign="stretch">
                <ng-container *ngFor="let item of processingValidations; let lastItem = last">
                  <div
                    fxFill
                    fxLayout="row"
                    fxLayoutAlign="center"
                    fxLayoutGap="0.5em"
                    (click)="selectWorkflow(item)"
                    class="text-padding"
                    [ngClass]="{ selected: isWorkflowSelected(item) }"
                  >
                    <mat-icon [ngStyle]="{ color: '#237c11' }">av_timer</mat-icon>
                    <div fxFill fxLayout="column" fxLayoutGap="0.5em">
                      <div class="validation-name" [matTooltip]="item.name" matTooltipClass="big-tooltip">
                        {{ item.name }}
                      </div>
                      <mat-progress-bar
                        matTooltip="{{ 'ProgressPanel.BatchesSent' | translate }}: {{ item.totalBatchesProcessed }}/{{
                          item.totalBatches
                        }}"
                        mode="determinate"
                        [value]="item.percentageProcessed"
                      >
                      </mat-progress-bar>
                    </div>
                  </div>
                  <mat-divider *ngIf="!lastItem"></mat-divider>
                </ng-container>
              </div>
            </div>
            <div *ngIf="hasValidationsCompleted()" fxLayout="column">
              <span fxLayout="start" class="status"> {{ 'ProgressPanel.Finished' | translate }}</span>
              <div fxLayout="column" fxFill fxLayoutAlign="stretch">
                <ng-container *ngFor="let item of validationsCompleted; let lastItem = last">
                  <div
                    fxFill
                    fxLayout="row"
                    fxLayoutAlign="center"
                    fxLayoutGap="0.5em"
                    (click)="selectWorkflow(item)"
                    class="text-padding"
                    [ngClass]="{ selected: isWorkflowSelected(item) }"
                  >
                    <mat-icon [ngStyle]="{ color: '#3ec902' }">check_circle</mat-icon>
                    <div fxFill fxLayout="column" fxLayoutGap="0.5em">
                      <div class="validation-name" [matTooltip]="item.name" matTooltipClass="big-tooltip">
                        {{ item.name }}
                      </div>
                      <mat-progress-bar
                        matTooltip="{{ 'ProgressPanel.BatchesSent' | translate }}: {{ item.totalBatchesProcessed }} / {{
                          item.totalBatches
                        }}"
                        mode="determinate"
                        value="100"
                      ></mat-progress-bar>
                    </div>
                  </div>
                  <mat-divider *ngIf="!lastItem"></mat-divider>
                </ng-container>
              </div>
            </div>
            <div *ngIf="hasValidationErrors()" fxLayout="column">
              <span fxLayout="start" class="status"> {{ 'ProgressPanel.Error' | translate }}</span>
              <div fxLayout="column" fxFill fxLayoutAlign="stretch">
                <ng-container *ngFor="let validationError of validationErrors; let lastvalidationError = last">
                  <div
                    fxFill
                    fxLayout="row"
                    fxLayoutAlign="center"
                    fxLayoutGap="0.5em"
                    (click)="selectWorkflow(validationError)"
                    class="text-padding"
                    [ngClass]="{ selected: isWorkflowSelected(validationError) }"
                  >
                    <mat-icon [ngStyle]="{ color: 'red' }">error</mat-icon>
                    <div fxFill fxLayout="column" fxLayoutGap="0.5em">
                      <div class="validation-name" [matTooltip]="validationError.name" matTooltipClass="big-tooltip">
                        {{ validationError.name }}
                      </div>
                      <div
                        class="error-message"
                        [matTooltip]="validationError.errorMessage"
                        matTooltipClass="big-tooltip"
                      >
                        {{ validationError.errorMessage }}
                      </div>
                    </div>
                  </div>
                  <mat-divider *ngIf="!lastItem"></mat-divider>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="hasSelectedWorkflow()" fxFlex="auto" style="width: 350px" class="text-padding">
            <mat-list class="mat-elevation-z1">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="overflow">
                  <h3 mat-subheader>{{ selectedWorkflow.name }}</h3>
                </div>
                <div class="icon" (click)="refreshItems()">
                  <mat-icon>refresh</mat-icon>
                </div>
              </div>
              <div
                fxLayout="row"
                style="padding-left: 12px"
                fxLayoutAlign="start end"
                fxLayoutGap="0.5rem"
                *ngIf="!isFinishedWorkflow()"
              >
                <button mat-raised-button color="primary" (click)="reprocess()">
                  {{ 'Actions.Rerun' | translate }}
                </button>
                <button mat-raised-button color="warn" (click)="cancel()">
                  {{ 'Actions.Cancel' | translate }}
                </button>
              </div>
              <mat-list-item *ngFor="let selectedItem of selectedItems">
                <h3 matLine>{{ selectedItem.statusItemName }}</h3>
                <p matLine>
                  <span class="subline">{{ selectedItem.date | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
                </p>
                <p *ngIf="isProcessingFile(selectedItem)" matLine>
                  {{ 'ProgressPanel.BatchesSent' | translate }}: {{ selectedItem.totalProcessed }} /
                  {{ selectedItem.total }}
                </p>
                <p *ngIf="isValidatingDocuments(selectedItem)" matLine>
                  {{ 'ProgressPanel.ValidatedDocuments' | translate }}: {{ selectedItem.totalProcessed }} /
                  {{ selectedItem.total }}
                </p>
                <p *ngIf="isProgressBar(selectedItem)" class="progress-bar" matLine>
                  <mat-progress-bar
                    mode="determinate"
                    color="primary"
                    [value]="selectedItem.percentageProcessed"
                  ></mat-progress-bar>
                </p>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>
    </dva-scrollbar>
  </mat-tab>
</mat-tab-group>
